import { useContext, useState, useEffect } from 'react';
import { ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { isValidPassword } from '../../services/UtilService'; // isValidPassword 함수 import
import { NumericFormat } from 'react-number-format';
import { useNavigate, useLocation } from 'react-router-dom';
import { isValidEmail } from '../../services/UtilService';
import { nlPost } from '../../apis/notLoginApi';

const EntJoin = () => {
  useEffect(() => {
    document.title = '기업 사용자 등록';
  }, []);

  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const [dplChkRslt, setDplChkRslt] = useState(null);
  const [dplChkBool, setDplChkBool] = useState(false);
  const [emlDplChkBool, setEmlDplChkBool] = useState(false);
  const [pswdCompare, setPswdCompare] = useState(null);
  const [pswdValid, setPswdValid] = useState(null);
  const [pswdValidMsg, setPswdValidMsg] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    mode: '',
    entId: '',
    entPswd: '',
    entPswdConfirm: '',
    brNo: '',
    entNm: '',
    entRprsv: '',
    entAddr: '',
    entDaddr: '',
    entZip: '',
    entTelno: '',
    entFxno: '',
    picNm: '',
    picTelno: '',
    picDept: '',
    picMblTelno: '',
    picEml: '',
    utztnTrmsAgreYn: '',
    prvcClctAgreYn: '',
    entSz: 'A',
    instCd: '',
    instNm: '',
  });

  // 미입력 필드 에러 테두리
  const [errors, setErrors] = useState({
    entId: false,
    entPswd: false,
    entPswdConfirm: false,
    entAddr: false,
    entDaddr: false,
    entNm: false,
    entRprsv: false,
    entZip: false,
    entTelno: false,
    picNm: false,
    picTelno: false,
    picDept: false,
    picMblTelno: false,
    picEml: false,
  });

  const entSz = [
    { value: 'A', label: '1~5인' },
    { value: 'B', label: '6~20인' },
    // { value: 'C', label: '21~100인' },
    { value: 'C-1', label: '21~49인' },
    { value: 'C-2', label: '50~100인' },
    { value: 'D', label: '101~300인' },
    { value: 'E', label: '301인 이상' },
  ];

  // 비밀번호와 비밀번호 확인 필드 비교
  useEffect(() => {
    setPswdCompare(formData.entPswd === formData.entPswdConfirm ? true : false);
  }, [formData.entPswd, formData.entPswdConfirm]);

  // 비밀번호 유효성 검사 useEffect
  useEffect(() => {
    if (
      pswdCompare == true &&
      formData.entPswd != '' &&
      formData.entPswdConfirm != '' &&
      formData.entPswdConfirm.length >= 8 &&
      formData.entPswd.length >= 8
    ) {
      validatePassword();
    } else if (pswdCompare == false) {
      setPswdValidMsg('비밀번호가 일치하지 않습니다.');
      setPswdValid(false);
    }
  }, [pswdCompare]);

  // 비밀번호 유효성검사 리턴 처리
  const validatePassword = () => {
    const result = isValidPassword(formData.entPswd); // utilService에서 가져온 함수 호출

    if (result) {
      setPswdValidMsg(result); // 에러 메시지를 설정
      setPswdValid(false); // 유효하지 않은 경우 처리
    } else {
      setPswdValidMsg('사용 가능한 비밀번호입니다.'); // 유효한 경우 메시지
      setPswdValid(true); // 유효한 경우 처리
    }
  };
  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;

    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 아이디 영문, 숫자만 입력
  const handleInput = e => {
    const { id, value } = e.target;

    if (/^[a-zA-Z0-9]*$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    } else {
      e.preventDefault();
    }
  };

  // 아이디 비밀번호 입력 input 붙여넣기 금지
  const handlePaste = e => {
    e.preventDefault();
  };

  // 아이디 중복확인
  const fnDplChk = () => {
    const url = '/member/duplicateIdChk.do';
    const param = {
      id: formData.entId.replace(/\s+/g, ''),
    };

    if (param.entId != '') {
      nlPost(url, param)
        .then(response => {
          setDplChkBool(response);
          if (response instanceof Error) {
            this.modalService.errorAlert(
              '데이터 처리중 에러가 발생하였습니다',
              () => {}
            );
          } else {
            if (response == false) {
              setDplChkRslt('사용 불가능한 아이디입니다.');
              setDplChkBool(false);
            } else if (response == true) {
              setDplChkRslt('사용 가능한 아이디입니다.');
              setDplChkBool(true);
            }
          }
        })
        .catch(error => {});
    } else if (param.entId == '') {
      setDplChkRslt('아이디를 입력해주세요.');
    }
  };

  const [entIdChg, setEntIdChg] = useState(true);
  const [picEmlChg, setPicEmlChg] = useState(true);

  useEffect(() => {
    setPicEmlChg(false);
  }, [formData.picEml]);

  // 카카오 주소 검색
  const handleAddressSearch = () => {
    new daum.Postcode({
      oncomplete: function (data) {
        setFormData(prevFormData => ({
          ...prevFormData,
          entAddr: data.roadAddress,
          entZip: data.zonecode,
        }));
      },
    }).open();
  };

  const validationCheck = async () => {
    const validationRules = {
      entId: { presence: true },
      entPswd: { presence: true },
      entPswdConfirm: { presence: true },
      brNo: { presence: true },
      entNm: { presence: true },
      entRprsv: { presence: true },
      entAddr: { presence: true },
      entDaddr: { presence: true },
      entZip: { presence: true },
      entTelno: { presence: true },
      picNm: { presence: true },
      picTelno: { presence: true },
      picDept: { presence: true },
      picMblTelno: { presence: true },
      picEml: { presence: true, email: true },
      utztnTrmsAgreYn: { presence: true },
      prvcClctAgreYn: { presence: true },
      entSz: { presence: true },
    };

    if (formData.instCd === 'write') {
      validationRules.instNm = { presence: true };
    }

    const altKey = {
      entId: '아이디',
      entPswd: '비밀번호',
      entPswdConfirm: '비밀번호 확인',
      brNo: '사업자등록번호',
      entNm: '기업명',
      entRprsv: '대표자명',
      entAddr: '주소',
      entDaddr: '상세주소',
      entZip: '우편번호',
      entTelno: '전화번호',
      picNm: '담당자명',
      picTelno: '담당자 전화번호',
      picDept: '담당자 부서',
      picMblTelno: '담당자 휴대전화',
      picEml: '담당자 이메일',
      utztnTrmsAgreYn: '이용약관 동의',
      prvcClctAgreYn: '개인정보 수집 동의',
      entSz: '기업 규모',
      instNm: '기관(협회)',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }

    if (formData.entPswd !== formData.entPswdConfirm) {
      modalService.noticeAlert('비밀번호가 일치하지 않습니다.', () => {});
      return;
    }

    if (!pswdValid) {
      modalService.noticeAlert(
        '비밀번호는 8자 이상, 영문, 숫자, 특수문자를 포함해야 합니다.',
        () => {}
      );
      return;
    }
    insertEntUser();
  };

  const dplChk = async () => {
    if (!dplChkBool) {
      modalService.errorAlert('아이디 중복확인을 해주세요.', () => {});
      return false;
    }
    if (!emlDplChkBool) {
      modalService.errorAlert('이메일 중복확인을 해주세요.', () => {});
      return false;
    }
    return true;
  };

  const joinProcess = async () => {
    try {
      const isDuplicateChecked = await dplChk();
      if (!isDuplicateChecked) return;
      const isValidation = await validationCheck();
      if (!isValidation) return;
    } catch {
      modalService.errorAlert('데이터 처리중 에러가 발생하였습니다.', () => {});
    }
  };

  const insertEntUser = () => {
    const url = '/member/insertEntUser.do';

    nlPost(url, formData)
      .then(response => {
        navigateTo('/member/joinCmplt');
      })
      .catch(error => {});
  };

  const handleInputChangeName = e => {
    const { id, value } = e.target;

    // 숫자가 포함되지 않은 경우에만 상태를 업데이트
    if (!/\d/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    }
  };

  const handleInputChangeText = e => {
    const { id, value } = e.target;

    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const handleInputChangeEml = e => {
    const { id, value } = e.target;

    // 한글 입력 방지
    const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value);
    if (isKorean) {
      return;
    }

    // 특수기호 제외 (@와 .은 허용)
    const isSpecialChar = /[^a-zA-Z0-9@.]/.test(value);
    if (isSpecialChar) {
      return;
    }

    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const fnValidateEmail = async email => {
    // controller.fnValidateEmail(formData.picEml);
    if (!isValidEmail(email)) {
      modalService.errorAlert('이메일 형식이 아닙니다.', () => {});
      setFormData(prevFormData => ({ ...prevFormData, picEml: '' }));
      return false;
    } else {
      return true;
    }
  };

  const navigateTo = url => {
    navigate(url);
  };

  const cancel = () => {
    navigateTo('/member/login');
  };

  useEffect(() => {
    if (location.state && location.state.brNo) {
      setFormData(prevFormData => ({
        ...prevFormData,
        mode: location.state.mode,
        brNo: location.state.brNo,
        utztnTrmsAgreYn: location.state.utztnTrmsAgreYn,
        prvcClctAgreYn: location.state.prvcClctAgreYn,
      }));
      setErrors(prevFormData => ({
        ...prevFormData,
        brNo: true,
      }));
    }
  }, [location.state]);

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (formData.entId.length !== undefined && formData.entId !== null) {
      if (formData.entId.length >= 6) {
        setIsDisabled(false);
      }
      if (formData.entId.length < 6) {
        setIsDisabled(true);
      }
    }
  }, [formData.entId]);

  // 유효성 검사 후
  const handleValidateAndCheck = async () => {
    const isValid = await fnValidateEmail(formData.picEml);
    if (isValid) {
      getEmlData();
    }
  };

  const getEmlData = () => {
    if (formData.picEml.length >= 5 && formData.picEml != null) {
      const url = '/member/duplicateUserEmlChk.do';
      const param = { userEml: formData.picEml };
      nlPost(url, param)
        .then(response => {
          if (response) {
            modalService.successAlert('사용 가능한 이메일 주소입니다.', () => {
              setPicEmlChg(response);
              setEmlDplChkBool(response);
            });
          } else {
            modalService.errorAlert('사용 불가능한 이메일 주소입니다.', () => {
              setPicEmlChg(response), setEmlDplChkBool(response);
              setFormData(prevFormData => ({
                ...prevFormData,
                picEml: '',
              }));
            });
          }
        })
        .catch(error => {});
    } else {
      modalService.errorAlert('이메일을 입력해주세요.', () => {});
    }
  };

  const handleInputChangeChk = e => {
    setFormData(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 가입</h2>
      </div>
      <ol className="step-wrap">
        <li className="done">
          <span>
            <i className="sr-only">1단계</i>
            <span className="step-tit">가입 유형 선택</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">2단계</i>
            <span className="step-tit">중복가입 확인</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">3단계</i>
            <span className="step-tit">약관동의</span>
          </span>
        </li>
        <li className="active">
          <span>
            <i className="sr-only">4단계 현재단계</i>
            <span className="step-tit">정보입력</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">5단계</i>
            <span className="step-tit">사용자 가입 완료</span>
          </span>
        </li>
      </ol>

      <h3 className="content-tit">정보입력</h3>
      <p className="text-gray-70">
        사용자 가입시 입력하신 정보는 사용자님의 동의 없이 공개되지 않으며,
        개인정보보호 정책에 따라 안전하게 보호받습니다.
      </p>
      <p className="tbl-msg gap-sm">
        <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
      </p>
      <div className="txt-box bg-white">
        <h4>기업정보</h4>
        <fieldset>
          <legend>기업정보 입력</legend>
          <div className="fieldset">
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="entId">
                  아이디<em className="star-require">*</em>
                </label>
              </div>
              <div className={`form-conts`}>
                <div className="input-group">
                  <input
                    type="text"
                    id="entId"
                    className="form-control"
                    placeholder="아이디를 입력해 주세요"
                    value={formData.entId || ''}
                    onChange={handleInput}
                    onKeyDown={handleKeyDown} // 아이디 스페이스바 금지
                    onPaste={handlePaste} // 아이디 붙여넣기 금지
                    maxLength={20}
                    aria-labelledby="entId"
                    disabled={dplChkBool}
                  />
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={fnDplChk} // 아이디 중복검사 함수 호출
                    disabled={isDisabled}
                  >
                    중복 확인
                  </button>
                </div>
              </div>
              {dplChkRslt !== null ? (
                <p
                  className={
                    dplChkBool == false ? 'text-point' : 'text-secondary'
                  }
                >
                  {dplChkRslt}
                </p>
              ) : null}
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entPswd">
                    비밀번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <input
                    type="password"
                    className="form-control"
                    id="entPswd"
                    value={formData.entPswd || ''}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown} // 비밀번호 스페이스바 금지
                    onPaste={handlePaste} // 비밀번호 붙여넣기 금지
                    maxLength={20}
                    aria-labelledby="entPswd"
                  />
                </div>
                <div style={{ height: '25.5px' }}>
                  {pswdValid !== null ? (
                    <p
                      className={
                        pswdCompare == true && pswdValid == true
                          ? 'text-secondary'
                          : 'text-point'
                      }
                    >
                      {pswdValidMsg}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entPswdConfirm">
                    비밀번호 확인<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts `}>
                  <input
                    type="password"
                    className="form-control"
                    id="entPswdConfirm"
                    value={formData.entPswdConfirm || ''}
                    onChange={handleInputChange}
                    onPaste={handlePaste} // 클립보드 내용 붙여넣기 방지
                    maxLength={20}
                    aria-labelledby="entPswdConfirm"
                  />
                </div>
                <div style={{ height: '25.5px' }}></div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entNm">
                    회사명
                    <em className="star-require">*</em>
                  </label>
                </div>

                <div className={`form-conts`}>
                  <input
                    type="text"
                    id="entNm"
                    value={formData.entNm || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    maxLength={20}
                    aria-labelledby="entNm"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entRprsv">
                    대표자
                    <em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <input
                    type="text"
                    className="form-control"
                    id="entRprsv"
                    value={formData.entRprsv || ''}
                    onChange={handleInputChangeName}
                    maxLength={20}
                    aria-labelledby="entRprsv"
                  />
                </div>
              </div>
            </div>

            {/* 기업규모 시작 */}
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entSz">
                    회사규모
                    <em className="star-require">*</em>
                  </label>
                </div>

                <div className={`form-conts`}>
                  {/* <input
                    type="text"
                    id="entNm"
                    value={formData.entNm || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    maxLength={20}
                  /> */}
                  <div className="input-group">
                    <label className="hidden-label" htmlFor="entSz">
                      라벨
                    </label>
                    <select
                      className="form-select"
                      name="entSz"
                      value={formData.entSz}
                      onChange={handleInputChangeChk}
                      id="entSz"
                    >
                      {entSz.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="inst">기관(협회)</label>
                </div>
                <div className={`form-conts`}>
                  <div className="input-group">
                    <label className="hidden-label" htmlFor="instCd">
                      라벨
                    </label>
                    <select
                      className="form-select"
                      name="instCd"
                      value={formData.instCd}
                      onChange={handleInputChangeChk}
                      id="instCd"
                    >
                      <option key="해당없음" value="해당없음">
                        해당없음
                      </option>
                      <option key="인공지능그랜드ICT" value="인공지능그랜드ICT">
                        인공지능그랜드ICT
                      </option>
                      <option key="부산경영자총협회" value="부산경영자총협회">
                        부산경영자총협회
                      </option>
                      <option
                        key="부산기계공업협동조합"
                        value="부산기계공업협동조합"
                      >
                        부산기계공업협동조합
                      </option>
                      <option key="부산벤처기업협회" value="부산벤처기업협회">
                        부산벤처기업협회
                      </option>
                      <option
                        key="한국선박수리공업협동조합"
                        value="한국선박수리공업협동조합"
                      >
                        한국선박수리공업협동조합
                      </option>
                      <option
                        key="한국재난안전사업기술연구조합"
                        value="한국재난안전사업기술연구조합"
                      >
                        한국재난안전사업기술연구조합
                      </option>
                      <option key="write" value="write">
                        직접입력
                      </option>
                    </select>
                    <label className="hidden-label" htmlFor="instNm">
                      라벨
                    </label>
                    <input
                      className="form-control"
                      id="instNm"
                      type="text"
                      placeholder="00협회, 00조합"
                      value={
                        formData.instCd === 'write'
                          ? formData.instNm
                          : formData.instCd
                      }
                      onChange={handleInputChangeText}
                      readOnly={formData.instCd === 'write' ? false : true}
                      maxLength={33}
                      aria-labelledby="taskNmLbl"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-title">
                주소<em className="star-require">*</em>
              </div>
              <div className={`form-conts`}>
                <div className="input-group" style={{ width: '68.37%' }}>
                  <label className="hidden-label" htmlFor="entAddr">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entAddr"
                    value={formData.entAddr || ''}
                    onChange={handleInputChange}
                    maxLength={200}
                    style={{ maxWidth: '406px' }}
                    readOnly
                    aria-labelledby="entAddr"
                  />
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={handleAddressSearch}
                  >
                    주소 찾기
                  </button>
                </div>
                <div className="input-group">
                  <div className={`form-conts `}>
                    <label className="hidden-label" htmlFor="entDaddr">
                      라벨
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="entDaddr"
                      value={formData.entDaddr || ''}
                      onChange={handleInputChange}
                      maxLength={200}
                      aria-labelledby="entDaddr"
                    />
                  </div>
                  <div>
                    <label className="hidden-label" htmlFor="entZip">
                      라벨
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="entZip"
                      value={formData.entZip || ''}
                      onChange={handleInputChange}
                      readOnly
                      maxLength={5}
                      aria-labelledby="entZip"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entTelno">
                    전화번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <NumericFormat
                    type="text"
                    id="entTelno"
                    className="form-control"
                    value={formData.entTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="entTelno"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entFxno">팩스번호</label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="entFxno"
                    className="form-control"
                    value={formData.entFxno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="entFxno"
                  />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <h4 className="gap-md">담당자 정보</h4>
        <fieldset>
          <legend>담당자 정보 입력</legend>
          <div className="fieldset">
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picNm">
                    담당자명<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <input
                    type="text"
                    className="form-control"
                    id="picNm"
                    value={formData.picNm || ''}
                    onChange={handleInputChangeName}
                    maxLength={20}
                    aria-labelledby="picNm"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picDept">
                    담당부서<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <input
                    type="text"
                    className="form-control"
                    id="picDept"
                    value={formData.picDept || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    aria-labelledby="picDept"
                  />
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picTelno">
                    전화번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <NumericFormat
                    type="text"
                    id="picTelno"
                    className="form-control"
                    value={formData.picTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="picTelno"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picMblTelno">
                    휴대전화<em className="star-require">*</em>
                  </label>
                </div>
                <div className={`form-conts`}>
                  <NumericFormat
                    type="text"
                    id="picMblTelno"
                    className="form-control"
                    value={formData.picMblTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    allowNegative={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    aria-labelledby="picMblTelno"
                  />
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picEml">
                    담당자 이메일 주소<em className="star-require">*</em>
                  </label>
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    id="picEml"
                    className="form-control"
                    value={formData.picEml || ''}
                    onChange={handleInputChangeEml}
                    onKeyDown={handleKeyDown} // 아이디 스페이스바 금지
                    onPaste={handlePaste} // 아이디 붙여넣기 금지
                    maxLength={50}
                    aria-labelledby="picEml"
                    disabled={emlDplChkBool}
                  />

                  <button
                    type="button"
                    className="btn secondary"
                    onClick={() => {
                      handleValidateAndCheck();
                    }}
                  >
                    중복 확인
                  </button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="page-btn-wrap">
        <button type="button" className="btn xlg tertiary" onClick={cancel}>
          취소
        </button>
        <button type="button" className="btn xlg primary" onClick={joinProcess}>
          회원가입 완료
        </button>
      </div>
    </>
  );
};

export default EntJoin;
